<div class="layout-content">
	<div *ngIf="fwUpdateStart">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<div *ngIf="!fwUpdateStart">
		<div class="grid flex align-items-center" *ngFor="let firmware of this.mtmaFirmwareUpdates, index as cont">
			<div [class]="!onExtendedMobile() ? 'col-8' : 'col-12 flex justify-content-center text-center'">
				<span>{{'MODULE_UPDATE' | translate }}: {{firmware.Description}} - {{'FROM_VERSION' | translate }}:
					{{firmware.DeviceFWVersion}} ---- {{'TO_VERSION' | translate }}: {{firmware.AvailableFWVersion}}</span>
			</div>
			<div [class]="!onExtendedMobile() ? 'col-4 flex justify-content-end' : 'col-12 flex justify-content-center'">
				<p-button label="{{ 'UPDATE_FIRWARE_MTMA' | translate }}" (click)="firmwareUpdate(firmware.Description)"
					[disabled]="offline() || onFirmwareUpdate()" icon="pi cm-update-firmware" severity="primary">
				</p-button>
			</div>
		</div>
	</div>
</div>